import React from "react";

type ReviewStarsProps = {
  value: number;
  max?: number;
  size?: "sm" | "md";
  onChange?: (value: number) => void;
  label?: string;
};

export default function ReviewStars({
  value,
  max = 5,
  size = "md",
  onChange,
  label,
}: ReviewStarsProps) {
  const starClass = size === "sm" ? "h-4 w-4" : "h-5 w-5";
  const rounded = Math.round(Number(value) || 0);

  return (
    <div className="inline-flex items-center gap-1" role={onChange ? "radiogroup" : "img"} aria-label={label || `${rounded} de ${max} estrelas`}>
      {Array.from({ length: max }, (_, index) => {
        const star = index + 1;
        const filled = star <= rounded;
        if (onChange) {
          return (
            <button
              key={star}
              type="button"
              aria-label={`${star} estrela${star > 1 ? "s" : ""}`}
              onClick={() => onChange(star)}
              className={`rounded p-0.5 ${filled ? "text-amber-500" : "text-gray-300"} hover:text-amber-500`}
            >
              <svg className={starClass} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </button>
          );
        }
        return (
          <svg
            key={star}
            className={`${starClass} ${filled ? "text-amber-500" : "text-gray-300"}`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        );
      })}
    </div>
  );
}
